var map = {
	"./activeAudits.svg": 66510,
	"./agent.svg": 14971,
	"./auditAgent.svg": 75812,
	"./auditAuditor.svg": 7097,
	"./auditCalendar.svg": 79239,
	"./auditClient.svg": 32048,
	"./auditCount.svg": 62370,
	"./auditDepartment.svg": 24459,
	"./auditFatel.svg": 21205,
	"./auditForm.svg": 92767,
	"./auditId.svg": 13774,
	"./auditInsure.svg": 78531,
	"./auditNoFatel.svg": 7574,
	"./auditProcess.svg": 5708,
	"./auditScore.svg": 54321,
	"./auditScoree.svg": 77214,
	"./auditStag.svg": 74188,
	"./auditTransaction.svg": 44571,
	"./audited.svg": 95034,
	"./auditor.svg": 1250,
	"./dashboardIcon.svg": 12623,
	"./dashboardUser.svg": 37093,
	"./departmentAction.svg": 60076,
	"./departmentDate.svg": 15278,
	"./departmentIcon.svg": 94065,
	"./departmentName.svg": 14559,
	"./departmentStatus.svg": 57000,
	"./downloadIcon.svg": 21675,
	"./fatelCount.svg": 40823,
	"./invoiceCount.svg": 8958,
	"./link.svg": 69200,
	"./manageUsers.svg": 31311,
	"./menuIcon.svg": 47554,
	"./nonFatelCount.svg": 55102,
	"./profileIcon.svg": 80624,
	"./qmsIcon.svg": 41446,
	"./reasonIcon.svg": 69447,
	"./searchIcon.svg": 53319,
	"./settingsIcon.svg": 49160,
	"./supervisor.svg": 52982,
	"./surveyLogo.svg": 27811,
	"./totalAudits.svg": 93502,
	"./transactionId.svg": 60255,
	"./voc.svg": 3708
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87623;